import { useAuth } from '@/contexts/AuthContext'
import type { Edition } from '@/types/auth'

export type EditionState = {
  /** Which product this account runs. */
  edition: Edition
  /** Single-measurement edition: no team, no templates, no respondent base. */
  isBasic: boolean
  isPro: boolean
}

/**
 * Product edition as carried on `/accounts/me/`. Every screen that shows or
 * hides something asks here — nothing reads `user.edition` directly.
 *
 * Fails open to Pro, matching `useSubscription()`: if the field is missing
 * (an older backend, a payload that arrived half-built, the moment before the
 * session loads) the account keeps everything it had. The backend is the
 * enforcement; this only decides what is worth drawing.
 */
export function useEdition(): EditionState {
  const { user } = useAuth()
  const edition: Edition = user?.edition === 'basic' ? 'basic' : 'pro'
  return { edition, isBasic: edition === 'basic', isPro: edition === 'pro' }
}
